export class ParcelCOD {
  amount: number

  constructor(amount: number) {
    this.amount = amount
  }
}
